import { type Control, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Box, Divider } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type CoverPhotoDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const CoverPhotoDetails = ({ control }: CoverPhotoDetailsProps) => {
  const { envelope } = useWatch({ control });
  const photoCount = envelope?.coverPhoto?.length ?? 0;

  const value = photoCount > 0 ? 'Added' : undefined;

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <PhotoCameraIcon fontSize="inherit" />
            <span>&nbsp;Cover photo</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Photo:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={isNil(value) ? 'textDisabled' : 'textPrimary'}>
            {isNil(value) ? '—' : value}
          </Typography>
        </Grid>
        <Divider />
      </Stack>
    </Box>
  );
};
